module.exports = new __parcel__URL__("marine3.fcc7792d.jpg").toString();